module.exports = __webpack_public_path__ + "static/media/logo-ppm-off.73921baa.svg";